<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-contract-org-inn" class="control-label">{{ inputLabel }}</label>
    <input-facade
        v-model="inputValue"
        masked
        :mask="getDocumentMask"
        :disabled="disabled"
        :tokens="inputFacadeTokens"
        :placeholder="getDocumentHint"
        id="form-contract-org-inn"
        class="form-control text-uppercase"
        @change="emitValue('change', $event)"
        @input="emitValue('input', $event)"
        @blur="emitValue('blur', $event)"
        @keydown="emit"
        @keyup="emit"
    />
    <template>
      <typeahead
        v-model="form.application.contract_org_inn"
        :async-function="typeahead"
        :item-key="typeaheadItemKey"
        :limit="typeaheadLimit"
        target="#form-contract-org-inn"
        @input="selectTypeahead($event, true)"
      >
        <template v-slot:item="props">
          <li
            v-for="(item, index) in props.items"
            :key="item.id"
            :class="{ active: props.activeIndex === index }"
          >
            <a role="button" @click="props.select(item)">
              <div v-html="props.highlight(item)"></div>
              <div v-if="item && item.inn">{{ item.inn}}</div>
              <div v-if="item && item.org_name">{{ item.org_name }}</div>
              <div v-if="item && item.address">{{ item.address}}</div>
            </a>
          </li>
        </template>
      </typeahead>
    </template>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import organizationSectionMixin from '@/common/mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '@/common/mixins/application-form/organizationInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'ContractOrgInnInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'ИНН'
    },

    inputName: {
      default: 'contract_org_inn'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputFacadeTokens() {
      return {
        '#': { pattern: /\d/ },
        S: { pattern: /[a-zA-Z]/ },
        R: { pattern: /[А-Яа-я]/ },
        N: { pattern: /[I|V|X|C|D|M|L]/i },
        M: { pattern: /[0-9А-Яа-яa-zA-Z]/ }
      }
    },

    getDocumentHint() {
      return this.getOrgSubResidency?.hint ?? ''
    },

    getDocumentMask() {
      return this.getOrgSubResidency?.mask ? JSON.parse(this.getOrgSubResidency?.mask) : 'XXXXXXXXXXXXXXXX'
    }
  }
}
</script>
